import { CATEGORY_PALETTE_SIZE, masterColor } from "@/shared/lib/masterColor"

interface MasterWithId {
  id: string
}

/**
 * Builds a de-collided colour-slot map for working masters.
 *
 * Algorithm (lifted from the deleted MasterTabs.vue):
 * 1. Walk `workingMasters` in API order; skip day-off masters.
 * 2. Compute base slot via `masterColor(id)` (FNV-1a hash mod palette size).
 * 3. Walk +1 mod CATEGORY_PALETTE_SIZE until a free slot is found.
 * 4. Record the slot; mark it taken.
 *
 * Day-off masters are excluded so their colour never appears in the grid header.
 */
export function buildMasterColorMap(
  workingMasters: MasterWithId[],
  dayOffMasterIds: Set<string>,
): Map<string, number> {
  const map = new Map<string, number>()
  const taken = new Set<number>()

  for (const master of workingMasters) {
    if (dayOffMasterIds.has(master.id)) continue

    let slot = masterColor(master.id) % CATEGORY_PALETTE_SIZE
    while (taken.has(slot)) {
      slot = (slot + 1) % CATEGORY_PALETTE_SIZE
    }
    taken.add(slot)
    map.set(master.id, slot)
  }

  return map
}
